<template>
  <div>
    <v-data-table mobile-breakpoint="0" item-key="id" :items-per-page="-1" :headers="headers" sort-by="name"
      :items="sortFee" v-bind="this.$attrs" loading-text="Đang Tải" :loading="loading" hide-default-footer>
      <template v-slot:no-data>
        <div class="my-14 font-weight-bold">
          <div>Vui lòng chọn kỳ đóng trên phần tìm kiếm.</div>
        </div>
      </template>
      <template v-slot:item.title="{ item }">
        <v-tooltip max-width="200px" color="grey darken-1" bottom>
          <template v-slot:activator="{ on }">
            <div v-on="on" class="nowrap ma-0 text-name">
              <router-link :to="'/head-fees/' + item.headFee.id" style="text-decoration: none">{{
                item.headFee.title
              }}
              </router-link>
            </div>
          </template>
          <span class="tooltip white--text">{{ item.headFee.title }}</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.headFee`]="{ item }">
        <span class="d-flex justify-end">+ {{ item.headFeeMoney ? item.headFeeMoney : 0 | price }}</span>
      </template>
      <template v-slot:[`item.deductionHeadFees`]="{ item }">
        <span class="d-flex justify-end">- {{ item.deductionFeeMoney ? item.deductionFeeMoney : 0 | price }}</span>
      </template>
      <template v-slot:[`item.arrearFees`]="{ item }">
        <span class="d-flex justify-end">+ {{ item.arrearFeeMoney ? item.arrearFeeMoney : 0 | price }}</span>
      </template>
      <template v-slot:[`item.refundFees`]="{ item }">
        <span class="d-flex justify-end">- {{ item.refundFeeMoney ? item.refundFeeMoney : 0 | price }}</span>
      </template>
      <template v-slot:[`item.total`]="{ item }">
        <span class="d-flex justify-end">{{ item.totalMoney ? item.totalMoney : 0 | price }}</span>
      </template>
    </v-data-table>
    <div v-if="totalHeadFee.length">
      <TotalMoney />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { header } from '@/modules/tuitionFee/financial-report/headerTable.js'
import TotalMoney from '@/modules/tuitionFee/financial-report/totalMoney.vue'

export default {
  components: {
    TotalMoney
  },
  data() {
    return {
      headers: header
    }
  },

  computed: {
    ...mapGetters({
      totalHeadFee: 'tuitionFeeReport/totalHeadFee',
      loading: 'tuitionFeeReport/loading'
    }),
    sortFee() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      let Fees = this.totalHeadFee.sort((a, b) => a.headFee.rank - b.headFee.rank)
      return Fees
    }
  }
}
</script>

<style scoped>
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: 300px;
}

.tooltip {
  word-wrap: break-word;
}
</style>
